var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3967 0.557376C12.2283 0.216072 11.8806 0 11.5 0C11.1194 0 10.7718 0.216072 10.6033 0.557376L7.74577 6.34647L1.3554 7.28051C0.978841 7.33555 0.666161 7.59956 0.548783 7.96157C0.431405 8.32358 0.529678 8.72083 0.802296 8.98636L5.42551 13.4894L4.33442 19.851C4.27007 20.2261 4.42432 20.6053 4.7323 20.8291C5.04027 21.0528 5.44856 21.0823 5.78548 20.9051L11.5 17.8998L17.2146 20.9051C17.5515 21.0823 17.9598 21.0528 18.2678 20.8291C18.5757 20.6053 18.73 20.2261 18.6656 19.851L17.5746 13.4894L22.1978 8.98636C22.4704 8.72083 22.5687 8.32358 22.4513 7.96157C22.3339 7.59956 22.0212 7.33555 21.6447 7.28051L15.2543 6.34647L12.3967 0.557376Z",
    fill: "#373F41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.811b359175b7fb94fb427dffa5cb7305.svg";
export { ForwardRef as ReactComponent };